<template>
    <CheckboxGroupField
        v-model="form.pet"
        name="pets"
        :label-classes="grid.md ? 'text-base' : ''"
        :options="OPTIONS.PETS"
        :columns="2"
        required
    >
        <TextField
            v-model="form.pet_other"
            :label="$t('generic.ls_lemonswan_generic_other')"
            class="col-start-1 md:col-start-2 col-end-3"
            :placeholder="$t('user.profile_overview.habit.placeholder.pets')"
        />
    </CheckboxGroupField>
</template>

<script setup>
import CheckboxGroupField from "@/Components/FormFields/CheckboxGroupField.vue";
import TextField from "@/Components/FormFields/TextField.vue";
import { OPTIONS } from "@/Helpers/constants.js";
import { getReviewItemValue } from "@/Helpers/reviewedItems.js";
import { useForm } from "@inertiajs/vue3";
import { useGrid } from "vue-screen";

const props = defineProps({
    pet: {
        type: Array,
        default: () => [],
    },
    petOther: {
        type: String,
        default: null,
    },
    form: {
        type: Object,
        default: null,
    },
});

const grid = useGrid("tailwind");

const form =
    props.form ??
    useForm({
        pet: props.pet,
        pet_other: getReviewItemValue(props.petOther),
    });
</script>
